// extracted by mini-css-extract-plugin
export default {"editMode":"ContentTypeImage_editMode__pbhzv"};